
var cache = {};

// Get a promise to load an image
// And re-use promises for the same image
function getImage(src) {
  cache[src] = cache[src] || promiseImage(src);
  return cache[src];
}

// return a promise to load an image
function promiseImage(src) {
  var defer = $.Deferred();
  var img = loadImage(src, ()=> {
    defer.resolve(img);
  });
  return defer.promise();
}

// traditional loadImage
function loadImage(src, onLoad) {
  var img = new Image();
  img.src = src;
  $(img).on('load', ()=> {
    try {
      if(onLoad) onLoad(img);
    } catch(e) {}
  });
  return img;
}

export default getImage;



// WEBPACK FOOTER //
// ./src/util/imageLoader.js